// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"87ecfcc9","118":"da5e4c5c","177":"021c45ea"}[chunkId] + ".css";
};